/**
 * Copyright Highway9 Networks Inc.
 */
import React from "react";
import { DialogBox, DialogContent, DialogTitle } from "@h9/ui-lib";
import ApiToken from "./ApiToken";

interface ApiTokenDialogProps {
  open: boolean;
  onClose: () => void;
}

const ApiTokenDialog = ({ open, onClose }: ApiTokenDialogProps) => {
  return (
    <DialogBox
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "80vw",
          height: "80vh",
          maxWidth: "1200px",
          maxHeight: "800px",
        },
      }}
    >
      <DialogTitle onClose={onClose}>
        API Token
      </DialogTitle>
      <DialogContent sx={{ p: 6, overflow: "auto" }}>
        <ApiToken />
      </DialogContent>
    </DialogBox>
  );
};

export default ApiTokenDialog;
